import { Kategorie } from '../kategorie/kategorie.model';
export class Kontakt{
    id: string;
    fax: string;
    funktion: string;
    nachname: string;
    telefon: string;
    vorname: string;
    hofberater: number;
    hofberaterSuchbar: string;
    isHofberater: boolean;
    email: string;
    kategorie: string;
    kategorieBezeichnung: string;
}